"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feature = void 0;
var Feature;
(function (Feature) {
    Feature[Feature["APPLY_CONSTRAINTS"] = 0] = "APPLY_CONSTRAINTS";
    Feature[Feature["AUDIO_CONTEXT"] = 1] = "AUDIO_CONTEXT";
    Feature[Feature["CPU_USAGE"] = 2] = "CPU_USAGE";
    Feature[Feature["CREATE_CANVAS_ELEMENT"] = 3] = "CREATE_CANVAS_ELEMENT";
    Feature[Feature["CREATE_VIDEO_ELEMENT"] = 4] = "CREATE_VIDEO_ELEMENT";
    Feature[Feature["CREATE_AUDIO_ELEMENT"] = 5] = "CREATE_AUDIO_ELEMENT";
    Feature[Feature["CREATE_SCREENSHOT"] = 6] = "CREATE_SCREENSHOT";
    Feature[Feature["DOCUMENT"] = 7] = "DOCUMENT";
    Feature[Feature["DEBUGGING"] = 8] = "DEBUGGING";
    Feature[Feature["HLSJS"] = 9] = "HLSJS";
    Feature[Feature["LOCAL_STORAGE"] = 10] = "LOCAL_STORAGE";
    Feature[Feature["MATCH_MEDIA"] = 11] = "MATCH_MEDIA";
    Feature[Feature["MULTI_TOUCH"] = 12] = "MULTI_TOUCH";
    Feature[Feature["MEDIA_DEVICE"] = 13] = "MEDIA_DEVICE";
    Feature[Feature["MEDIA_RECORDER"] = 14] = "MEDIA_RECORDER";
    Feature[Feature["MEDIA_SOURCE"] = 15] = "MEDIA_SOURCE";
    Feature[Feature["MEDIA_STREAM"] = 16] = "MEDIA_STREAM";
    Feature[Feature["NETWORK_INFORMATION"] = 17] = "NETWORK_INFORMATION";
    Feature[Feature["URL_LOCATION"] = 18] = "URL_LOCATION";
    Feature[Feature["SCREEN_ORIENTATION"] = 19] = "SCREEN_ORIENTATION";
    Feature[Feature["WEB_SOCKET"] = 20] = "WEB_SOCKET";
    Feature[Feature["WEB_SOCKET_CLIENT"] = 21] = "WEB_SOCKET_CLIENT";
    Feature[Feature["PERMISSIONS"] = 22] = "PERMISSIONS";
    Feature[Feature["MPEGTS"] = 23] = "MPEGTS";
    Feature[Feature["URL_SEARCHPARAMS"] = 24] = "URL_SEARCHPARAMS";
    Feature[Feature["USER_ACTIVATION"] = 25] = "USER_ACTIVATION";
    Feature[Feature["USER_AGENT_DATA"] = 26] = "USER_AGENT_DATA";
    Feature[Feature["WEBRTC"] = 27] = "WEBRTC";
})(Feature || (exports.Feature = Feature = {}));
//# sourceMappingURL=feature.js.map